import React from "react";

export default function TableActions({
  data,
  setShowId,
  setDeleteId,
  setEditId,
  button1,
  button2,
  button3,
}) {
  return (
    <div className="table-element bg-transparent">
      <div className="d-flex">
        {button1 ? (
          <img
            role="button"
            src={`${process.env.PUBLIC_URL}/assets/${button1}.svg`}
            alt="show"
            onClick={() => setShowId(data)}
          />
        ) : (
          <></>
        )}
        {button2 ? (
          <img
            role="button"
            src={`${process.env.PUBLIC_URL}/assets/${button2}.svg`}
            alt="edit"
            onClick={() => {
              setEditId(data);
            }}
          />
        ) : (
          <></>
        )}
        {button3 ? (
          <img
            role="button"
            src={`${process.env.PUBLIC_URL}/assets/${button3}.svg`}
            alt="delete"
            onClick={() => setDeleteId(data)}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
